import React from 'react';
import _ from 'underscore';
import { useReportApiCalls } from '../report-api-calls';
import { recentReportsDataSource } from './recent-reports';
import { loadingReportsDataSource, loadingReportsStore } from './loading-reports';
import { globalMenuSavedReportsDataSource } from './global-menu-saved-reports';


function refreshBothOnSuccess(apiCall) {
  return async function wrappedApiCall(...args) {
    const res = await apiCall(...args);

    recentReportsDataSource.refresh();
    globalMenuSavedReportsDataSource.refresh();

    return res;
  };
}

function withCancel(promise) {
  let canceled = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then((data) => {
      if (!canceled) {
        resolve(data);
      }
    }).catch((err) => {
      if (!canceled) {
        reject(err);
      }
    });
  });

  wrappedPromise.cancel = () => { canceled = true; };

  return wrappedPromise;
}

const reportsApiFactory = _.memoize(({ reportApiCalls }) => {
  const currentCalls = {};
  function previewReport(body) {
    const report = body.ReportData;
    const { Id = 0, ReportType } = report;
    loadingReportsStore.add(report);
    loadingReportsDataSource.refresh();

    const reqKey = `${ReportType}-${Id}`;
    if (currentCalls[reqKey]) {
      currentCalls[reqKey].cancel();
      delete currentCalls[reqKey];
    }

    const call = withCancel(reportApiCalls.previewReport(body));
    currentCalls[reqKey] = call;

    call
      // No matter the call success or fail, always do these
      .finally(() => {
        loadingReportsStore.remove(report);
        loadingReportsDataSource.refresh();
        recentReportsDataSource.refresh();
      });

    return call;
  }


  const saveReport = refreshBothOnSuccess(reportApiCalls.patchTaskItem);

  const saveAsNewReport = refreshBothOnSuccess(reportApiCalls.submitReportDataTaskItem);

  const deleteReports = refreshBothOnSuccess(reportApiCalls.deleteReports);

  const refreshRecentReportsDataSource = () => recentReportsDataSource.refresh();

  return {
    ...reportApiCalls,
    previewReport,
    saveReport,
    saveAsNewReport,
    deleteReports,
    refreshRecentReportsDataSource,
  };
});

// custom hook for function component
export function useReportDataSource() {
  const reportApiCalls = useReportApiCalls();

  return reportsApiFactory({ reportApiCalls });
}


// HoC for class component
export function withReportDataSource(Comp) {
  return function CompWrapper(props) {
    const reportsApiProps = useReportDataSource();

    return <Comp {...props} {...reportsApiProps} />;
  };
}
